export default __webpack_public_path__ + "static/media/T.3ac94605.svg";